import React from 'react';

export const DisplayFormikState = props =>
    <div style={{ margin: '1rem 0' }}>
    <pre
      style={{
        background: '#e6f8fa',
        fontSize: '1.2rem',
        padding: '.5rem',
      }}
    >
      <strong>props</strong> ={' '}
      {JSON.stringify(props, null, 2)}
    </pre>
  </div>;
